function normalizeString(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

const IVA_CONDITIONS = [
  {
    code: 'RI',
    label: 'Responsable Inscripto',
    aliases: [
      'ri',
      'responsable inscripto',
      'iva responsable inscripto',
      'resp inscripto',
      'responsable inscripto (inferido)',
    ],
  },
  {
    code: 'MT',
    label: 'Monotributo',
    aliases: ['mt', 'mo', 'monotributo', 'monotributista'],
  },
  {
    code: 'EX',
    label: 'Exento',
    aliases: ['ex', 'exento'],
  },
  {
    code: 'CF',
    label: 'Consumidor Final',
    aliases: ['cf', 'consumidor final', 'no responsable'],
  },
  {
    code: 'RNI',
    label: 'Responsable no inscripto',
    aliases: ['rni', 'responsable no inscripto', 'no inscripto'],
  },
  {
    code: 'SNC',
    label: 'Sujeto no categorizado',
    aliases: ['snc', 'sujeto no categorizado'],
  },
];

function findIvaCondition(rawCondition) {
  const normalized = normalizeString(rawCondition);
  if (!normalized) return null;
  return IVA_CONDITIONS.find(condition => condition.aliases.includes(normalized)) || null;
}

export function mapAfipResponsabilidadIva(rawCondition, { format = 'label', fallback = '' } = {}) {
  const condition = findIvaCondition(rawCondition);
  if (!condition) {
    return String(rawCondition || fallback || '').trim();
  }
  return format === 'code' ? condition.code : condition.label;
}

export function getAfipAutofillResetPatch() {
  return {
    razonSocial: '',
    condicionIVA: '',
    direccion: '',
    provincia: '',
    localidad: '',
    codigoLocalidad: '',
    codigoPostal: '',
    domicilioCalle: '',
    domicilioNumero: '',
    domicilioPiso: '',
    domicilioDpto: '',
    pisoDepto: '',
  };
}

export function mergeAfipObservaciones(previousValue, afipData) {
  const base = String(previousValue || '')
    .replace(/\n?\n?--- DATOS AFIP ---[\s\S]*$/m, '')
    .trim();

  const details = [
    afipData?.tipoPersona
      ? `Tipo: ${afipData.tipoPersona}${afipData.formaJuridica ? ` (${afipData.formaJuridica})` : ''}`
      : '',
    afipData?.estadoContribuyente ? `Estado: ${afipData.estadoContribuyente}` : '',
    afipData?.condicionIVA ? `Condición IVA: ${afipData.condicionIVA}` : '',
    afipData?.actividadPrincipal ? `Actividad: ${afipData.actividadPrincipal}` : '',
    afipData?.localidad ? `Localidad AFIP: ${afipData.localidad}` : '',
  ].filter(Boolean);

  if (details.length === 0) {
    return base;
  }

  const afipBlock = `--- DATOS AFIP ---\n${details.join('\n')}`;
  return base ? `${base}\n\n${afipBlock}` : afipBlock;
}

export function normalizeAfipCliente(afipData = {}, currentData = {}) {
  const condicionIVA = mapAfipResponsabilidadIva(afipData.condicionIVA, { format: 'label' });
  const condicionIVACode = mapAfipResponsabilidadIva(afipData.condicionIVA, { format: 'code' });

  return {
    cuit: afipData.cuit || currentData.cuit || '',
    tipoDocumento: afipData.tipoDocumento || currentData.tipoDocumento || '',
    razonSocial: afipData.razonSocial || currentData.razonSocial || '',
    condicionIVA,
    afipCondicionIVACode: condicionIVACode,
    afipCondicionIVARaw: afipData.condicionIVA || '',
  };
}

export function buildClientePayload(cliente = {}) {
  const razonSocial = String(
    cliente.razonSocial || cliente.razon || cliente.nombre || cliente.nombreFantasia || ''
  ).trim();
  const cuit = String(cliente.cuit || cliente.doc || cliente.documento || '').trim();
  const digits = cuit.replace(/\D/g, '');
  const tipoDocumento =
    cliente.tipoDocumento || (digits.length === 11 ? 'CUIT' : digits.length >= 7 ? 'DNI' : '');
  const condicionIVA = mapAfipResponsabilidadIva(
    cliente.condicionIVA || cliente.condicionIva || cliente.iva || cliente.condicion_iva,
    { format: 'label' },
  );
  const emailsSource = cliente.emails ?? cliente.email;
  const emails = Array.isArray(emailsSource)
    ? emailsSource.filter(Boolean)
    : String(emailsSource || '')
        .split(',')
        .map(item => item.trim())
        .filter(Boolean);

  return {
    ...cliente,
    razonSocial,
    tipoDocumento,
    cuit,
    condicionIVA,
    // `CategoriaCliente` es un enum GraphQL: EVENTUAL no existe en el schema.
    categoriaCliente: cliente.categoriaCliente || 'Minorista',
    direccion: cliente.direccion || '',
    telefono: cliente.telefono || '',
    celular: cliente.celular || '',
    emails,
  };
}

export function normalizeClientIvaCondition(rawCondition) {
  return mapAfipResponsabilidadIva(rawCondition, { format: 'label' });
}
